import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = ({ color = ds.colorValue.icon.primary, ...props }: SvgProps) => (
    <Svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
        <Path
            d="M7.65625 4.16504L12.8456 9.35438C13.4314 9.94017 13.4314 10.8899 12.8456 11.4757L7.65625 16.665"
            stroke={color}
            strokeWidth={1.75}
            strokeLinejoin="round"
        />
    </Svg>
);
export { SvgComponent as ChevronRightRounded };
